export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind, DrawerProps} from 'kpc';

interface Props {
    show?: boolean
    placement: DrawerProps['placement']
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            show: false,
            placement: 'right' as Props['placement'],
        };
    }

    @bind
    showDrawer() {
        this.set('show', true);
    }
}